import React from "react";
import { connect } from "react-redux";

import { bindActionCreators, Dispatch } from "redux";

import { SelectionMode, DataTableDef } from "@plex/react-components";

import { useLocalizedValues } from "ui/hooks";
import { displayMessages } from "ui/screens/translation-managers";

import { messageRelationshipsActions } from "../MessageRelationships.actions";
import { IMessageRelationshipsState, IMessage } from "../MessageRelationships.state";

export interface IMessageRelationshipsGridGridProps {
  relationships: IMessage[];
  selectExistingRelationship: (messageId: IMessage[]) => void;
  selectedRelationship: IMessage[];
}

const MessageRelationshipsGrid: React.FC<IMessageRelationshipsGridGridProps> = ({ relationships, selectExistingRelationship, selectedRelationship }) => {
  const localizedValues = useLocalizedValues(() => ({
    messageIdTitle: displayMessages.property("messageId"),
    textTitle: displayMessages.property("text")
  }));

  return (
    <DataTableDef<IMessage>
      selected={selectedRelationship}
      keySelector={row => row.messageId}
      selectionMode={SelectionMode.single}
      data={relationships}
      onSelectionChanged={selectExistingRelationship}
    >
      <DataTableDef.Column<IMessage> id="messageId" key="1" sortable shortTitle={localizedValues.messageIdTitle} valueSelector={row => row.messageId}>
        {row => row.messageId}
      </DataTableDef.Column>
      <DataTableDef.Column<IMessage> id="text" key="2" sortable shortTitle={localizedValues.textTitle} valueSelector={row => row.text}>
        {row => row.text}
      </DataTableDef.Column>
    </DataTableDef>
  );
};

export default connect(
  (state: { messageRelationships: IMessageRelationshipsState }) => {
    return {
      relationships: state.messageRelationships.relationships,
      selectedRelationship: state.messageRelationships.selectedRelationship
    };
  },
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        selectExistingRelationship: messageRelationshipsActions.selectExistingRelationship
      },
      dispatch
    )
)(MessageRelationshipsGrid);
